
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class CouponContent extends Vue {
  @Prop({ default: () => {} })
  couponData: any;
}
